import { Banner, Button, TextField } from "@omony/ui";
import { useMutation } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { useIntl } from "react-intl";
import { api, errorMessageId } from "../../shared/api.js";
import { AuthLayout } from "../../shared/auth/AuthLayout.js";
import { navigate } from "../../shared/hashRoute.js";
import { queryClient, refreshSession } from "../../shared/query.js";
import styles from "../console.module.css";

/** Kopplung als Kiosk: Einmal-Code aus der Verwaltung (8 Zeichen, 15 min gültig). */
export function PairScreen() {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const m = useMutation({
    mutationFn: () => api("/device/pair", { method: "POST", body: { code, name: name.trim() || undefined } }),
    onSuccess: async () => {
      navigate("");
      await queryClient.invalidateQueries({ queryKey: ["device"] });
      await refreshSession();
    },
  });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    m.mutate();
  };
  return (
    <AuthLayout appTitle={t("app.apotheke")} title={t("console.pair.title")} lead={t("console.pair.lead")}>
      <form className={styles.form} onSubmit={submit} noValidate>
        {m.error ? <Banner tone="danger">{t(errorMessageId(m.error))}</Banner> : null}
        <TextField
          label={t("console.pair.code")}
          code
          value={code}
          onChange={(v) => setCode(v.toUpperCase().slice(0, 12))}
          autoComplete="off"
          enterKeyHint="go"
          description={t("console.pair.codeHint")}
          isRequired
        />
        <TextField
          label={t("console.pair.name")}
          value={name}
          onChange={setName}
          description={t("console.pair.nameHint")}
        />
        <div className={styles.actions}>
          <Button variant="quiet" onPress={() => navigate("")}>
            {t("auth.backToLogin")}
          </Button>
          <Button
            type="submit"
            size="lg"
            isDisabled={m.isPending || code.replace(/[^0-9A-Z]/g, "").length < 8}
          >
            {t("console.pair.submit")}
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
}
